
export default function FormsExtensionHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-cyan-50 to-white overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <div className="text-center">
          <div className="inline-flex items-center px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-8">
            <i className="ri-star-line mr-2"></i>
            企业级智能表单解决方案
          </div>
          
          <h1 className="text-5xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            <strong>PDF Forms Extension SDK</strong>
            <span className="block bg-gradient-to-r from-teal-600 via-cyan-600 to-teal-700 bg-clip-text text-transparent mt-4">
              智能表单处理开发工具包
            </span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-gray-600 mb-12 max-w-4xl mx-auto leading-relaxed">
            基于AI技术的<strong>智能表单识别</strong>和<strong>数据提取SDK</strong>，支持多种表单格式，提供完整的API接口和开发文档，助力企业实现<strong>表单处理自动化</strong>
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <button className="bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              <i className="ri-download-line mr-2"></i>
              立即下载SDK
            </button>
            <button className="border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-book-open-line mr-2"></i>
              查看文档
            </button>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg mb-4 mx-auto">
                <i className="ri-speed-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">99.5%</h3>
              <p className="text-gray-600">识别准确率</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-teal-500 rounded-lg mb-4 mx-auto">
                <i className="ri-file-list-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">50+</h3>
              <p className="text-gray-600">支持表单类型</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg mb-4 mx-auto">
                <i className="ri-timer-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">&lt;2秒</h3>
              <p className="text-gray-600">平均处理时间</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
